import intlTelInput from 'intl-tel-input';

const listeners = {};
const originalEventListener = window.addEventListener;
window.addEventListener = function (type, fn, options) {
  if (!listeners[type]) listeners[type] = [];

  listeners[type].push(fn);
  // DEV NOTE: prevent closing dropdown from the library for ios devices this is temporary workaround
  // and I made bug report in the library about this issue
  if (type === 'scroll' && fn.toString().includes('_closeDropdown')) {
    return;
  }
  return originalEventListener(type, fn, options);
};

export const preferredCountries = backEndVars.preferredCountries || [];

export const init = inputPhone => {
  const dropdownContainer = document.querySelector('.js-phone-container') || document.body;

  const iti = intlTelInput(inputPhone, {
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.1.1/build/js/utils.js',
    initialCountry: 'auto',
    customContainer: 'peer',
    useFullscreenPopup: false,
    preferredCountries,
    customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
      return '(e.g.) ' + selectedCountryPlaceholder;
    },
    // separateDialCode:true, this can be added if we want to appear next to the flag the intl code +359
    dropdownContainer,
  });

  const countryCode = preferredCountries[0] || 'us';
  const storedCountry = iti.getSelectedCountryData().iso2;

  const phoneLabel = document.querySelector('.phone-label');

  if (phoneLabel) {
    const phoneLabelCopy = phoneLabel.cloneNode(true);
    inputPhone.after(phoneLabelCopy);
    phoneLabel.remove();
  }

  let currentCountry = storedCountry || countryCode;
  try {
    iti.setCountry(currentCountry);
  } catch (e) {
    iti.setCountry(countryCode);
    currentCountry = countryCode;
  }

  iti.setNumber(store.get('__ph') || inputPhone.defaultValue || '');

  const hiddenField = document.querySelector('#phone_country_code');

  if (hiddenField) {
    hiddenField.value = currentCountry;
  }

  return iti;
};
